import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { MirrorService } from 'services/MirrorService';

import { useSiteInfoQuery } from 'hooks/queries/useSiteInfoQuery';

import css from './midsFooter.module.sass';

export const MidsFooter = () => {
  const { t } = useTranslation(['app', 'common']);

  const { pathname } = useLocation();

  const { data: siteInfoData } = useSiteInfoQuery();

  if (
    pathname === '/' ||
    pathname.includes('/terms') ||
    pathname.includes('/privacy-policy') ||
    pathname.includes('/tracking-policy') ||
    pathname.includes('/refund-policy') ||
    pathname.includes('/billing-policy') ||
    pathname.includes('/myprofile') ||
    pathname.includes('/settings')
  ) {
    return null;
  }

  return (
    <p className={css.copyright}>
      {siteInfoData && (
        <Trans
          i18nKey="footerMids"
          ns="app"
          values={{
            domain: MirrorService.domain,
            address: siteInfoData.address,
          }}
        />
      )}
      {MirrorService.isUnionHorizonMids && ', info@unionhorizons.com'}
      <div className={css.terms}>
        <Link to="/terms" className={css.policyLink}>
          {t('app:termsOfUse')}
        </Link>
        <Link to="/refund-policy" className={css.policyLink}>
          {t('common:refundPolicy')}
        </Link>
        <Link to="/privacy-policy" className={css.policyLink}>
          {t('common:privacyPolicy')}
        </Link>
        <Link to="/tracking-policy" className={css.policyLink}>
          {t('common:trackingpolicy')}
        </Link>
        <Link to="/billing-policy" className={css.policyLink}>
          {t('common:billingPolicy')}
        </Link>
      </div>
    </p>
  );
};
